import { render } from "./CustomForm.vue?vue&type=template&id=4f09c78b&scoped=true&ts=true"
import script from "./CustomForm.vue?vue&type=script&lang=ts"
export * from "./CustomForm.vue?vue&type=script&lang=ts"

import "./CustomForm.scss?vue&type=style&index=0&id=4f09c78b&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f09c78b"]])

export default __exports__